
import React from 'react';
import HeroImage from "@/assets/images/contact_hero.jpg";


const HeroSection: React.FC = () => {
  return (
    <section className="relative h-96 bg-gradient-to-r from-gray-900 to-gray-700 flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('${HeroImage}')`
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
      </div>
      
      <div className="relative z-10 text-center text-white px-4">
        <h1 className="text-5xl font-bold mb-4">Get in Touch</h1>
        <p className="text-xl text-gray-200 max-w-2xl mx-auto">
          We're here to bring your project to life with precision and expertise
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
